import Vue from "vue";
import { Icon } from "./index";
export default Vue.extend({
    inheritAttrs: false,
    components: {
        Icon,
    },
    props: {
        value: {
            type: [String, Number, Date, Object, InputEvent],
            default: "",
        },
        type: {
            type: String,
            default: "text",
        },
        placeholder: {
            type: String,
            default: "",
        },
        appendIcon: {
            type: String,
            default: "",
        },
        prependIcon: {
            type: String,
            default: "",
        },
        iconSize: {
            type: Number,
            default: 20,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        appendIconProps: {
            type: Object,
            default: () => ({}),
        },
        appendIconBtnProps: {
            type: Object,
            default: () => ({}),
        },
        prependIconProps: {
            type: Object,
            default: () => ({}),
        },
        prependIconBtnProps: {
            type: Object,
            default: () => ({}),
        },
        appendIconFill: {
            type: String,
            default: "none",
        },
        prependIconFill: {
            type: String,
            default: "none",
        },
    },
    data() {
        return {
            innerValue: "",
            isSecured: false,
        };
    },
    computed: {
        inputType() {
            const type = this.type === "password" ? "text" : this.type;
            return this.isSecured ? "password" : type;
        },
        isPassword() {
            return this.type === "password";
        },
        appendedIcon() {
            if (this.isPassword) {
                return this.isSecured ? "eye.close" : "eye.open";
            }
            return this.appendIcon;
        },
        hasButtons() {
            return (!!this.$slots.append ||
                !!this.$slots.prepend ||
                !!this.prependIcon ||
                !!this.appendIcon);
        },
    },
    watch: {
        innerValue(val) {
            var _a, _b;
            if (val instanceof InputEvent) {
                val = (_b = (_a = val) === null || _a === void 0 ? void 0 : _a.target) === null || _b === void 0 ? void 0 : _b.value;
            }
            this.$emit("input", val);
        },
        value: {
            immediate: true,
            handler(val) {
                this.innerValue = val;
            },
        },
        type: {
            immediate: true,
            handler(val) {
                if (val === "password") {
                    this.isSecured = true;
                }
            },
        },
    },
    methods: {
        onAppendClick() {
            this.$emit("append:click");
            if (this.isPassword) {
                this.isSecured = !this.isSecured;
            }
        },
        onPrependClick() {
            this.$emit("prepend:click");
        },
        focus() {
            this.$refs.inputRef.focus();
        },
        clear() {
            this.innerValue = "";
            this.$nextTick(this.focus);
        },
    },
});
